declare var SimpleBar;
declare var loggedTc;

namespace AgerLMS.WebSite {

    export interface WebSiteWidgetRequest {
        dm: boolean;
    }

    @Serenity.Decorators.registerClass()
    export class WebSiteWidget extends Serenity.Widget<WebSiteWidgetRequest> {
        userId : string = $("meta[name='userId']").attr("content");
        constructor(element: JQuery, opt: WebSiteWidgetRequest) {
            super(element, opt);

            var self = this;
            $('.dropdown-menu .simple-bar').each((i, e) => new SimpleBar(e));
            self.subscribetotheNewsletter();
            self.preventRightClicks();
            self.hidePhoneText();
        }

        preventRightClicks() {
            if (!this.options.dm && this.userId != "1") {
                var neolcak = () => Q.log("hop dedik abii ne oluyor yanii!!!");
                document.addEventListener(
                    "contextmenu",
                    function (t) {
                        neolcak();
                        return t.preventDefault();
                    },
                    !1
                );
                //prevent ctrl + u and ctrl + shift + i and f12
                $(document).keydown(function (event) {
                    if (event.keyCode == 123) {
                        neolcak();
                        return false;
                    } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
                        neolcak();
                        return false;
                    } else if (event.ctrlKey && event.keyCode == 85) {
                        neolcak();
                        return false;
                    }
                });
            }
        }

        hidePhoneText() {
            var callus = $("#call-us").text();
            if (callus.length > 0 && $(window).width() < 390) $("#call-us").html($("#call-us svg").attr("title", callus).get(0).outerHTML);
        }

        subscribetotheNewsletter() {
            $("#SubscribetotheNewsletter").click((e) => {
                e.preventDefault();
                var email = $("#NewsletterEmail").val();
                if (email == "") {
                    $("#NewsletterEmail").addClass("is-invalid");
                    SweetAlert.swal_alert("Hata", "Lütfen e-posta adresinizi giriniz.");
                    return;
                }
                //Email validation regex 
                var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
                if (!emailReg.test(email)) {
                    SweetAlert.swal_alert("Hata", "Lütfen geçerli bir e-posta adresi giriniz.");
                    return;
                }

                //Bültene kayıt şuan için aktif değil.
                // SweetAlert.swal_info("Bilgi", "Bültene kayıt şuan için aktif değil.");
                var newLetterEntity = <Logging.NewsletterRow>{};
                newLetterEntity.Email = email;
                Logging.NewsletterService.Create({
                    Entity: newLetterEntity
                }, 
                response => {
                    $("#NewsletterEmail").val("");
                    SweetAlert.swal_success_then("Başarılı", "Bültene kayıt işleminiz başarıyla gerçekleştirilmiştir.", () => {
                        window.location.reload();
                    });
                }, {
                    onError: (er) => {
                        $("#NewsletterEmail").val("");
                        SweetAlert.swal_alert("Hata", er.Error.Message);
                    }
                });
            });
        }
    }
}